// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// The result a pharmacist records for a lab in Clinical Review (carerx_lab_results.pos_neg).
// Mirrors functions/CareRx/LabResultCodes.cs — the server refuses anything else. Codes are short
// because the column is NVARCHAR(12); people read the labels.

/**
 * Answers for any lab. "indet" is stored short: the full word is 13 characters and the column holds
 * 12, so saving "indeterminate" always failed (SQL 2628). People still read "indeterminate".
 */
export const BASE_RESULTS = ['negative', 'positive', 'indet'] as const
/**
 * How CBC/CMP panels are actually read (ASP ticket 2026-09-30). Never offered on a SCREENING lab
 * (TB, hepatitis, HIV…): "within range" says nothing about an infection screen and would step
 * around the "positive → Screening & Hold" prompt. The server enforces the same rule.
 */
export const NORMAL_RANGE_RESULTS = ['wnl', 'outside_wnl'] as const

const LABELS: Record<string, string> = {
  wnl: 'Labs Within Normal Range',
  outside_wnl: 'Labs Outside Normal Range',
  indet: 'indeterminate',
  na: 'N/A',
}

/** What a person reads for a stored code; unknown codes fall back to the old "snake to words". */
export function resultLabel(code: string | null | undefined): string {
  if (!code) return ''
  return LABELS[code.toLowerCase()] ?? code.replace(/_/g, ' ')
}

/** The options for one lab: the normal-range pair only where no screening rule keys on it. */
export function resultOptionsFor(isScreeningLab: boolean): string[] {
  return isScreeningLab ? [...BASE_RESULTS] : [...BASE_RESULTS, ...NORMAL_RANGE_RESULTS]
}
